export const LOCAL_API_SERVER = 'http://localhost:5000'
export const PROD_API_SERVER  = 'https://koptische-gemeinde.de/cgi-bin/api.cgi'